import { axiosInstance as Axios } from "@/main";

export default {
  state: {
    showModalLogin: false,
    showModalInfo: false,
    showModalSignUp: false,
    showModalRecoverPassword: false,

    user: JSON.parse(localStorage.getItem("user0.1")) || {
      nome: null,
      telefonePrincipal: null
    },

    token: localStorage.getItem("token") || "",
    error: null
  },

  mutations: {
    set_modalLogin(state, payload) {
      state.showModalLogin = payload;
    },

    set_modalSignUp(state, payload) {
      state.showModalSignUp = payload;
    },

    set_modalRecoverPassword(state, payload) {
      state.showModalRecoverPassword = payload;
    },

    set_user(state, payload) {
      state.user = payload;

      localStorage.setItem(
        "user0.1",
        JSON.stringify(state.user)
      );
    },

    set_token(state, payload) {
      state.token = payload.token;

      if (state.token) {
        localStorage.setItem("token", state.token);
      }
    },

    unset_token(state) {
      state.token = "";

      localStorage.removeItem("token");
    },

    set_error(state, payload) {
      state.error = payload;
    }
  },

  actions: {
    logoff(store) {
      store.commit("set_user", {
        nome: null,
        telefonePrincipal: null
      });

      store.commit("unset_token");
    },

    set_modalLogin(store, payload) {
      store.commit("set_modalLogin", payload);
    },

    set_modalSignUp(store, payload) {
      store.commit("set_modalSignUp", payload);
    },

    set_modalRecoverPassword(store, payload) {
      store.commit(
        "set_modalRecoverPassword",
        payload
      );
    },

    login_social(store, payload) {
      store.commit("set_token", payload);

      return store.dispatch(
        "load_user",
        payload
      );
    },

    async login_token(store, payload) {
      try {
        let result = await Axios.get(
          `/auth/restore/${payload.token}`
        );

        store.commit(
          "set_token",
          result.data
        );

        store.dispatch(
          "load_user",
          payload
        );
      } catch (e) {
        store.commit("unset_token");

        store.commit(
          "set_error",
          "Token Inválido ou Expirado"
        );
      }
    },

    async login(store, payload) {
      try {
        let result = await Axios.post(
          "/auth/login",
          {
            email: payload.email,
            senha: payload.senha
          }
        );

        store.commit(
          "set_token",
          result.data
        );

        store.dispatch(
          "load_user",
          payload
        );
      } catch (e) {
        store.commit(
          "set_user",
          null
        );

        store.commit(
          "unset_token"
        );

        store.commit(
          "set_error",
          "Usuário ou Senha Inválidos"
        );

        throw e;
      }
    },

    set_user(store, payload) {
      store.commit(
        "set_user",
        payload.user
      );

      store.dispatch(
        "send_user",
        payload
      );
    },

    async send_user(store, payload) {
      try {
        await Axios.post(
          `${payload.url}configs/sessao/identificacao`,
          {
            nome: store.getters.user.nome,
            telefone:
            store.getters.user.telefonePrincipal
          },
          {
            headers: {
              "X-Token-Sessao":
              store.getters.session
            }
          }
        );
      } catch (e) {
        console.log(e);
      }
    },

    async load_user(store, payload) {
      try {
        let result = await Axios.get(
          `${payload.url || ""}protected/me`,
          {
            headers: {
              "X-Organizacao-ID":
              payload.organizationId,

              Authorization:
                `Bearer ${store.getters.token}`
            }
          }
        );

        store.commit(
          "set_user",
          result.data
        );

        store.dispatch(
          "set_modalLogin",
          false
        );

        store.dispatch(
          "set_modalSignUp",
          false
        );

        store.dispatch(
          "set_modalRecoverPassword",
          false
        );

        if (
          typeof payload.redirect ===
          "function"
        ) {
          payload.redirect();
        }
      } catch (e) {
        console.log(e);

        store.commit(
          "set_user",
          null
        );

        store.commit(
          "unset_token"
        );

        store.commit(
          "set_error",
          "Usuário ou Senha Inválidos"
        );
      }
    }
  },

  getters: {
    show_modalLogin(state) {
      return state.showModalLogin;
    },

    show_modalSignUp(state) {
      return state.showModalSignUp;
    },

    show_modalRecoverPassword(state) {
      return state.showModalRecoverPassword;
    },

    show_modalInfo(state) {
      return state.showModalInfo;
    },

    token(state) {
      return state.token;
    },

    user(state) {
      return state.user;
    },

    error(state) {
      return state.error;
    }
  }
};